import { ErrorHandler, Injectable } from '@angular/core';

import { NewRelicService } from './new-relic.service';

@Injectable()
export class NewRelicErrorHandlerService implements ErrorHandler {
  constructor(private readonly newRelic: NewRelicService) {}

  handleError(error: any) {
    this.newRelic.noticeError(error);

    // eslint-disable-next-line no-console
    console.error(error);
  }
}
